import { render, staticRenderFns } from "./config-page.vue?vue&type=template&id=276e5362&scoped=true&"
import script from "./config-page.vue?vue&type=script&lang=js&"
export * from "./config-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e5362",
  null
  
)

export default component.exports